var Constants = {
  // Normal UI events
  CLICKED: 'CLICKED',
  RESIZED: 'RESIZED',
  SCROLLED: 'SCROLLED',

  // Data changes
  FORM_FIELD_CHANGED: 'FORM_FIELD_CHANGED',
  FORM_SUBMIT: 'FORM_SUBMIT',
  CITY_UPDATE: 'CITY_UPDATE',
  PRICE_UPDATE: 'PRICE_UPDATE',
  BOOKING_QUOTE_UPDATE: 'BOOKING_QUOTE_UPDATE',
  BOOKING_QUOTE_ERROR: 'BOOKING_QUOTE_ERROR',
  CHANGE_PAGE_DATE_RANGE: 'CHANGE_PAGE_DATE_RANGE',

  CHANGE_CONTEXT_CITY: 'CHANGE_CONTEXT_CITY',
  CHANGE_CONTEXT_DATES: 'CHANGE_CONTEXT_DATES',
  CHANGE_CONTEXT_CURRENCY: 'CHANGE_CONTEXT_CURRENCY',
  CHANGE_GUEST_BUDGET: 'CHANGE_GUEST_BUDGET',

  SEARCH_UPDATE_FILTERS: 'SEARCH_UPDATE_FILTERS',
  SEARCH_FETCH_SUCCESS: 'SEARCH_FETCH_SUCCESS',

  // Specific UI interactions
  CHANGE_ACTIVE_FIELDSET: 'CHANGE_ACTIVE_FIELDSET',
  CHANGE_ACTIVE_ROOM: 'CHANGE_ACTIVE_ROOM',
  CHANGE_ACTIVE_CONTAINER: 'CHANGE_ACTIVE_CONTAINER',
  SELECT_MEDIA: 'SELECT_MEDIA',
  UNSELECT_MEDIA: 'UNSELECT_MEDIA',
  ASSIGN_MEDIA: 'ASSIGN_MEDIA',
  UNASSIGN_MEDIA: 'UNASSIGN_MEDIA',
  DRAG_MEDIA_START: 'DRAG_MEDIA_START',
  DRAG_MEDIA_OVER: 'DRAG_MEDIA_OVER',
  DRAG_MEDIA_END: 'DRAG_MEDIA_END',
  TEXT_EXPANDED: 'TEXT_EXPANDED',
  OPEN_GALLERY: 'OPEN_GALLERY',
  CLOSE_GALLERY: 'CLOSE_GALLERY',
  CHANGE_ACTIVE_GALLERY_IMAGE: 'CHANGE_ACTIVE_GALLERY_IMAGE',
  SHOW_GALLERY_HEADER: 'SHOW_GALLERY_HEADER',
  HIDE_GALLERY_HEADER: 'HIDE_GALLERY_HEADER',
  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',

  ADD_POPOVER: 'ADD_POPOVER',
  ADD_MODAL: 'ADD_MODAL',
  ADD_TOOLTIP: 'ADD_TOOLTIP',
  REMOVE_LAYER: 'REMOVE_LAYER',

  PUSH_ENQUIRY_EVENT: 'PUSH_ENQUIRY_EVENT',
  PUSH_GENERIC_EVENT: 'PUSH_GENERIC_EVENT',
  PUSH_FORM_SUBMIT: 'PUSH_FORM_SUBMIT',

  HIGHLIGHT_CALENDAR_DATE: 'HIGHLIGHT_CALENDAR_DATE',
  HIGHLIGHT_CALENDAR_RANGE: 'HIGHLIGHT_CALENDAR_RANGE',
  UNHIGHLIGHT_CALENDAR_DATE: 'UNHIGHLIGHT_CALENDAR_DATE',
  START_CALENDAR_RANGE_SELECTION: 'START_CALENDAR_RANGE_SELECTION',
  COMPLETE_CALENDAR_RANGE_SELECTION: 'COMPLETE_CALENDAR_RANGE_SELECTION',

  SIMILAR_HOMES_LOAD: 'SIMILAR_HOMES_LOAD',
  SIMILAR_HOMES_UPDATE: 'SIMILAR_HOMES_UPDATE',

  CONTENT_MODULE_ADD: 'CONTENT_MODULE_ADD',
  CONTENT_MODULE_CHANGE_VALUE: 'CONTENT_MODULE_CHANGE_VALUE',
  CONTENT_MODULE_REMOVE: 'CONTENT_MODULE_REMOVE',
  CONTENT_MODULES_REPLACE: 'CONTENT_MODULES_REPLACE',

  // Guest Store
  CHANGE_GUEST_NUMBER: 'CHANGE_GUEST_NUMBER',

  // Language Store
  ACCEPT_LANGUAGE_WARNING: 'ACCEPT_LANGUAGE_WARNING',
  SET_LANGUAGE: 'SET_LANGUAGE',

  // Scroll Store
  DISABLE_SCROLL: 'DISABLE_SCROLL',
  ENABLE_SCROLL: 'ENABLE_SCROLL',
  SCROLL_TO: 'SCROLL_TO',

  // Introduction Store
  RESET_REQUEST_ERROR: 'RESET_REQUEST_ERROR',
};

module.exports = Constants;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/constants.js
 **/